const initialState = null;

function packIdReducer(state = initialState, action) {
  switch (action.type) {
    case "packId/update":
      return action.payload;
    default:
      return state;
  }
}

export default packIdReducer;
